var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-2",
    "data-name": "info",
    transform: "translate(1.333 1.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    cx: 6.667,
    cy: 6.667,
    r: 6.667,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_53",
    "data-name": "Linha 53",
    y1: 2.667,
    transform: "translate(6.667 6.667)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_54",
    "data-name": "Linha 54",
    x2: 0.007,
    transform: "translate(6.667 4)",
    fill: "none",
    stroke: "#354d9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c5e0d30039a39149e1f8a6391a2a9e3d.svg";
export { ForwardRef as ReactComponent };